function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentPartsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 30 30",
    id: "svg822",
    fill: "#fcfcfc",
    stroke: "#fcfcfc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-289.0625)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M 11 3 L 11 6 L 9 6 C 7.3552972 6 6 7.3553 6 9 L 6 11 L 3 11 L 3 13 L 6 13 L 6 17 L 3 17 L 3 19 L 6 19 L 6 21 C 6 22.6447 7.3552972 24 9 24 L 11 24 L 11 27 L 13 27 L 13 24 L 17 24 L 17 27 L 19 27 L 19 24 L 21 24 C 22.644703 24 24 22.6447 24 21 L 24 19 L 27 19 L 27 17 L 24 17 L 24 13 L 27 13 L 27 11 L 24 11 L 24 9 C 24 7.3553 22.644703 6 21 6 L 19 6 L 19 3 L 17 3 L 17 6 L 13 6 L 13 3 L 11 3 z M 9 8 L 21 8 C 21.571297 8 22 8.4287 22 9 L 22 21 C 22 21.5713 21.571297 22 21 22 L 9 22 C 8.4287028 22 8 21.5713 8 21 L 8 9 C 8 8.4287 8.4287028 8 9 8 z M 13 12 C 12.446 12 12 12.446 12 13 L 12 17 C 12 17.554 12.446 18 13 18 L 17 18 C 17.554 18 18 17.554 18 17 L 18 13 C 18 12.446 17.554 12 17 12 L 13 12 z ",
    transform: "translate(0,289.0625)",
    id: "rect920"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentPartsLogo);
export default __webpack_public_path__ + "static/media/equipment_parts_logo.7f79e93ba8e658353608584ee4ced43e.svg";
export { ForwardRef as ReactComponent };